import { INotificationChannel } from '../../../../models/types';

const SOUND_CAP = 'SUPPORT_SOUND';

// true, если выбранный канал доставки среди channelSpecs декларирует звуковое оповещение.
// Имя поля капы в ответе /notification/types не гарантировано (тип заявляет channelCap,
// но в реальных ответах наблюдалось channelСap с кириллической С), поэтому капу сравниваем
// по ЗНАЧЕНИЮ, а не по имени ключа.
export const channelSupportsSound = (
  channels: INotificationChannel[],
  channelType?: string
): boolean => {
  if (!channelType) return false;
  const specs = channels.find(channel => channel.channelType === channelType)?.channelSpecs ?? [];
  return specs.some(spec =>
    Object.values(spec).some(value => typeof value === 'string' && value.toUpperCase() === SOUND_CAP)
  );
};
